import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-1b4279c4")
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "p-mb-2 pickup_and_dropoff" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-comment" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Note ")
const _hoisted_5 = {
  key: 0,
  class: "p-fluid p-mt-3"
}
const _hoisted_6 = {
  key: 1,
  class: "p-fluid p-mt-3"
}
const _hoisted_7 = {
  key: 2,
  class: "p-fluid p-mt-3"
}
const _hoisted_8 = { class: "actions" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h2", { class: "p-mb-0" }, " Assegna l'ordine ", -1)
const _hoisted_10 = { class: "p-d-flex" }
const _hoisted_11 = { class: "p-field-radiobutton" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "taker_radio" }, "Taker", -1)
const _hoisted_13 = { class: "p-field-radiobutton p-ml-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "supplier_radio" }, "Fornitore", -1)
const _hoisted_15 = {
  key: 0,
  class: "p-mt-3"
}
const _hoisted_16 = { class: "p-inputgroup" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" })
], -1)
const _hoisted_18 = {
  key: 0,
  class: "p-mt-3"
}
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Fornitore selezionato ")
const _hoisted_20 = { class: "p-grid" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "p-col-5 p-sm-3 p-md-3" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Nome: ")
], -1)
const _hoisted_22 = { class: "p-col-7 p-sm-5 p-md-6" }
const _hoisted_23 = { class: "p-grid" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "p-col-5 p-sm-3 p-md-3" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Cognome: ")
], -1)
const _hoisted_25 = { class: "p-col-7 p-sm-5 p-md-6" }
const _hoisted_26 = { class: "p-fluid p-mt-3" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OrderData = _resolveComponent("OrderData")!
  const _component_CustomerSummary = _resolveComponent("CustomerSummary")!
  const _component_PickerSummary = _resolveComponent("PickerSummary")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!
  const _component_Card = _resolveComponent("Card")!
  const _component_PriceAndCostSummary = _resolveComponent("PriceAndCostSummary")!
  const _component_Button = _resolveComponent("Button")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_PDialog = _resolveComponent("PDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_OrderData, {
      order: _ctx.order,
      showWarningTime: true,
      readonly: true
    }, null, 8, ["order"]),
    _createVNode(_component_CustomerSummary, {
      class: "p-mb-2",
      customer: _ctx.order.customer,
      orderCode: _ctx.order.external_client_code
    }, null, 8, ["customer", "orderCode"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_PickerSummary, {
        type: "ritiro",
        picker: _ctx.pickupPicker,
        savePicker: _ctx.order.is_save_new_pickup
      }, null, 8, ["picker", "savePicker"]),
      _createVNode(_component_PickerSummary, {
        type: "consegna",
        picker: _ctx.dropoffPicker,
        savePicker: _ctx.order.is_save_new_dropoff
      }, null, 8, ["picker", "savePicker"])
    ]),
    _createVNode(_component_Card, { class: "p-mb-3" }, {
      title: _withCtx(() => [
        _hoisted_3,
        _hoisted_4
      ]),
      content: _withCtx(() => [
        (_ctx.isTMT)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_FloatLabel, { label: "Note interne" }, {
                default: _withCtx(() => [
                  _createVNode(_component_Textarea, {
                    autoResize: true,
                    modelValue: _ctx.note_tmt,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.note_tmt = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.isTMT || _ctx.isCustomer)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_FloatLabel, {
                label: _ctx.isCustomer ? 'Note' : 'Note per il cliente'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Textarea, {
                    autoResize: true,
                    modelValue: _ctx.note_customer,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.note_customer = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isTMT || _ctx.isSupplier)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_FloatLabel, {
                label: _ctx.isSupplier ? 'Note' : 'Note per il fornitore/taker'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Textarea, {
                    autoResize: true,
                    modelValue: _ctx.note_supplier,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.note_supplier = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.saveResponse)
      ? (_openBlock(), _createBlock(_component_PriceAndCostSummary, {
          key: 0,
          order: _ctx.saveResponse,
          isReadonly: !_ctx.isTMT,
          class: "p-mb-3"
        }, null, 8, ["order", "isReadonly"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      (_ctx.isTMT && _ctx.saveResponse)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_Button, {
              label: "Aggiorna ordine",
              disabled: _ctx.requestPending,
              onClick: _ctx.update
            }, null, 8, ["disabled", "onClick"]),
            _createVNode(_component_Button, {
              label: "Inserisci nuovo",
              icon: "pi pi-save",
              disabled: _ctx.requestPending,
              onClick: _ctx.restart
            }, null, 8, ["disabled", "onClick"])
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.isTMT)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  label: "Salva",
                  icon: "pi pi-save",
                  loading: _ctx.requestPending,
                  onClick: _ctx.save
                }, null, 8, ["loading", "onClick"]))
              : _createCommentVNode("", true),
            (_ctx.isCustomer)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  label: "Salva e vai al pagamento",
                  icon: "pi pi-save",
                  loading: _ctx.savingInProgress,
                  onClick: _ctx.saveAndPay
                }, null, 8, ["loading", "onClick"]))
              : _createCommentVNode("", true),
            (_ctx.isTMT)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 2,
                  label: "Salva e assegna",
                  icon: "pi pi-tag",
                  loading: _ctx.requestPending,
                  onClick: _ctx.saveAndAssign
                }, null, 8, ["loading", "onClick"]))
              : _createCommentVNode("", true)
          ], 64))
    ]),
    _createVNode(_component_PDialog, {
      visible: _ctx.showAssignDialog,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => (_ctx.showAssignDialog = $event)),
      style: { width: '450px' },
      modal: true,
      class: "p-fluid",
      onHide: _ctx.onHide,
      draggable: true,
      keepInViewPort: true,
      minX: 0,
      minY: 0
    }, {
      header: _withCtx(() => [
        _hoisted_9
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Annulla",
          class: "p-secondary",
          onClick: _ctx.closeDialog
        }, null, 8, ["onClick"]),
        _createVNode(_component_Button, {
          label: "Conferma",
          onClick: _ctx.onConfirm
        }, null, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_RadioButton, {
                id: "taker_radio",
                name: "entityType",
                value: _ctx.takerValue,
                modelValue: _ctx.entityType,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.entityType = $event))
              }, null, 8, ["value", "modelValue"]),
              _hoisted_12
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_RadioButton, {
                id: "supplier_radio",
                name: "entityType",
                value: _ctx.supplierValue,
                modelValue: _ctx.entityType,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.entityType = $event))
              }, null, 8, ["value", "modelValue"]),
              _hoisted_14
            ])
          ]),
          (_ctx.entityType === _ctx.supplierValue)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createVNode(_component_AutoComplete, {
                    completeOnFocus: "",
                    modelValue: _ctx.searchBox,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.searchBox = $event)),
                    suggestions: _ctx.suggestions,
                    field: "name",
                    minLength: 2,
                    placeholder: "Cerca fornitore per nome ",
                    onItemSelect: _ctx.onSelect,
                    onComplete: _ctx.search
                  }, null, 8, ["modelValue", "suggestions", "onItemSelect", "onComplete"])
                ]),
                (_ctx.selected)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createVNode(_component_Card, { class: "p-shadow-2" }, {
                        title: _withCtx(() => [
                          _hoisted_19
                        ]),
                        content: _withCtx(() => [
                          _createElementVNode("div", _hoisted_20, [
                            _hoisted_21,
                            _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.selected.name), 1)
                          ]),
                          _createElementVNode("div", _hoisted_23, [
                            _hoisted_24,
                            _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.selected.surname), 1)
                          ]),
                          _createElementVNode("div", _hoisted_26, [
                            _createVNode(_component_FloatLabel, {
                              label: _ctx.$t('entity.business_note')
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Textarea, {
                                  autoResize: true,
                                  modelValue: _ctx.selected.business_note,
                                  readonly: ""
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ], 32)
      ]),
      _: 1
    }, 8, ["visible", "onHide"])
  ]))
}